// src/components/TransformRoofCTA.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TransformRoofCTA.css';

// Import FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPhone, 
  faCalendarCheck, 
  faArrowRight, 
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';

function TransformRoofCTA() {
  const [animated, setAnimated] = useState(false);

  // Animation on scroll
  useEffect(() => {
    const handleScroll = () => {
      const element = document.querySelector('.transform-cta');
      if (!element) return;
      
      const position = element.getBoundingClientRect();
      if (position.top < window.innerHeight * 0.75 && !animated) {
        setAnimated(true);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [animated]);

  return (
    <section className="transform-cta">
      <div className="cta-pattern"></div>
      <div className="container">
        <div className={`cta-content ${animated ? 'animated' : ''}`}>
          <h2>Ready to Transform Your Roof?</h2>
          <p>
            Contact us today for a free consultation and quote. 
            Our expert team is ready to provide you with the highest quality roofing solutions.
          </p>
          
          <div className="cta-benefits">
            <div className="cta-benefit">
              <FontAwesomeIcon icon={faCheckCircle} className="benefit-icon" />
              <span>Free No-Obligation Quote</span>
            </div>
            <div className="cta-benefit">
              <FontAwesomeIcon icon={faCheckCircle} className="benefit-icon" />
              <span>Professional Installation</span>
            </div>
            <div className="cta-benefit">
              <FontAwesomeIcon icon={faCheckCircle} className="benefit-icon" />
              <span>Quality Materials</span>
            </div>
            <div className="cta-benefit">
              <FontAwesomeIcon icon={faCheckCircle} className="benefit-icon" />
              <span>Satisfaction Guaranteed</span>
            </div>
          </div>
          
          <div className="cta-buttons">
            <Link to="/contact" className="cta-btn contact-btn">
              <FontAwesomeIcon icon={faCalendarCheck} className="btn-icon" />
              Get a Free Quote
              <FontAwesomeIcon icon={faArrowRight} className="arrow-icon" />
            </Link>
            
            <a href="tel:07735005695" className="cta-btn call-btn">
              <FontAwesomeIcon icon={faPhone} className="btn-icon" />
              Call Now: 07735 005 695
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TransformRoofCTA;